import { createQueryKeys } from '@lukemorales/query-key-factory';
import { productList, ProductListParams } from 'services/api/conversation';

export const products = createQueryKeys('products', {
  list: (params: ProductListParams) => ({
    queryKey: [params],
    queryFn: ({ signal }) => productList(params, signal),
  }),
});
